export default __webpack_public_path__ + "static/media/Oats.3c26317d.jpg";